<template>
  <div>

    <div class="map__container">
      <div class="inner-wrapper">
        <a :href="backToListUrl" class="inner-wrapper__link">
          <div class="inner-wrapper__icon"></div>
          <span class="inner-wrapper__text">Все отделения</span>
        </a>
      </div>
    </div>

    <div style="width: 100%; position: relative;">
      <div class="map__frame-cont map__frame-cont_branch" v-if="ODPPreview !== null">

        <span class="loader-overlay" v-if="ODPLoading">
          <span class="loader-img"></span>
        </span>

        <ODPPreview
          class="map__container map__container_card  map__container_largeview"
          :ODPPreview="ODPPreview"
          :buildRoute="buildRoute"
          :hideODPPreview="hideODPPreview"
        />
      </div>

      <div class="map__container map-branch" style="position: relative;">

        <div class="loader-overlay" v-if="initPointsData === null">
          <span class="loader-img"></span>
        </div>
        <YmapsView
          style="width: 100%; height: 676px;"
          ref="ymapsViewOdp"
          :initPointsData="initPointsData"
          :searchODP="searchODP"
          :ODPPreview="ODPPreview"
          @select="onOdpSelect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import YmapsView from './YmapsView.vue';
import ODPPreview from './ODPPreview.vue';
import URL from '../../helpers/url';
import * as odpRepository from '../../store/odp.repository';

const emptyMapJson = () => import(
  /* webpackChunkName: "emptyMapJson" */
  '../emptyMap.json'
);

export default {
  name: 'OdpPageView',
  props: {
    msg: String,
  },
  components: {
    YmapsView,
    ODPPreview,
  },
  methods: {
    hideODPPreview() {
      this.ODPPreview = null;
    },
    buildRoute(e, odp) {
      e.preventDefault();
      // Берем и узнаем положение пользователя, если мы его не узнаем, все тлен.
      this.$refs.ymapsViewOdp.getUserLocation(odp);
      this.ODPPreview = odp;
    },
    getInitPoints(code) {
      odpRepository.default.findInCity(code)
        .then((resp) => {
          // self.pager = resp.data.pager;
          this.initPointsData = resp;
        })
        .catch((error) => {
          // self.initPointsData = null;
          console.log(error);
          // @FIXME: Это похоже fallback на карту всей России
          emptyMapJson().then((module) => {
            this.initPointsData = module.default;
          });
        });
    },
    onOdpSelect(odpId) {
      if (odpId && odpId !== this.searchODP) {
        this.searchODP = odpId;

        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        window.history.pushState(window.location.origin, null,
          `/find_an_office/${odpId}${window.location.search ? `?${window.location.search.replace(/^\?+/, '')}` : ''}`);
      }
    },
  },
  mounted() {
    const urlParts = window.location.pathname.split('/');
    this.searchODP = urlParts[urlParts.length - 1];

    const url = new URL(window.location.href);
    const fromParameter = url.searchParam('from');

    if (fromParameter) {
      try {
        this.backToListUrl = `/find_an_office?${decodeURIComponent(atob(decodeURIComponent(fromParameter)))}`;
      } catch {
        // Не удалось декодировать параметр, значит переходы будут без заданных фильтров
        this.backToListUrl = '/find_an_office?view=list';
      }
    }
  },
  data() {
    return {
      ODPLoading: false,
      OdpPage: false,
      ODPPreview: null,
      showFilter: false,
      queryString: [],
      receptionLap: false,
      interRefunds: false,
      acquiring: false,
      isOpenOnWeekends: false,
      initListCollection: [],
      initPointsData: null,
      initPointsDataList: {},
      isCourier: false,
      searchODP: null,
      odpInViewPort: true,
      searchQueryODP: '',
      backToListUrl: '/find_an_office?view=list',
    };
  },
  watch: {
    searchODP(newValue, oldValue) {
      this.ODPLoading = true;
      odpRepository.default
        .find(newValue)
        .then((odp) => {
          this.ODPPreview = odp.data;
          if (!oldValue) {
            this.getInitPoints(this.ODPPreview.cityCode);
          }
        })
        .finally(() => {
          this.ODPLoading = false;
        });
    },
  },
};

</script>

<style lang="scss" scoped>

  /*.map__frame-cont {
    position: absolute;
    top: 0;
    right: 0;

    @media(max-width: 1050px) {
      position: static;
    }
  }
*/
  .map__container_up {
    padding-top: 35px;
    position: relative;
    z-index: 99;
  }

  .map-nav__button_submenu {
    min-width: 50px;
    max-width: 50px;

    .map-nav__submenu {
      width: 300px;
      left: -250px;
      right: -250px;
      top: -1px;
    }

    .filter-icon {
      margin-right: 0;
    }
  }

  @media(max-width: 1200px) {
    .map-nav__button_submenu {
      min-width: 300px;

      .map-nav__submenu {
        left: -1px;
        right: -1px;
      }
    }
  }

  @media(max-width: 767px) {
    .map-nav__button_submenu {
      width: 100%;
      max-width: 320px;

      .map-nav__submenu {
        left: -1px;
        right: -1px;
      }
    }
  }

  @media(max-width: 580px) {

    .map-nav__button_submenu {
      max-width: none;
      flex: 1 1 100%;
    }

    .map-nav__submenu {
      width: 100% !important;
      left: -1px !important;
      right: -1px !important;
    }
  }


</style>
